import styled from "styled-components";

export const StyledSection7 = styled.div`
  .section7-container {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
    padding: 32px 0;
  }
`;
